import { render, staticRenderFns } from "./ForcePassword.vue?vue&type=template&id=02821398&"
import script from "./ForcePassword.vue?vue&type=script&lang=js&"
export * from "./ForcePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports